/* SeQR homepage: quick add to cart, paper-tag demo */
(function () {
  if (window.__seqrHome) return; window.__seqrHome = true;

  function addItem(variantId, btn) {
    var card = btn.closest('.p-card') || document;
    var err = card.querySelector('[data-error]'); if (err) err.hidden = true;
    var notif = document.querySelector('cart-notification');
    var sections = notif ? ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'] : ['cart-icon-bubble'];
    var label = btn.textContent;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status || res.errors) { throw new Error(res.description || res.message || 'Could not add to cart'); }
      if (typeof window.opusOpen === 'function') {
        try { var bh = res.sections && res.sections['cart-icon-bubble'], bb = document.getElementById('cart-icon-bubble'); if (bh && bb) { var bs = new DOMParser().parseFromString(bh, 'text/html').querySelector('.shopify-section'); if (bs) bb.innerHTML = bs.innerHTML; } } catch (e) {}
        Promise.resolve(typeof window.opusRefreshCart === 'function' ? window.opusRefreshCart() : null).catch(function () {}).then(function () { try { window.opusOpen(); } catch (e) {} });
      } else if (notif && res.items && res.items[0]) { res.key = res.items[0].key; res.id = res.items[0].id; try { notif.renderContents(res); } catch (e) { window.location.href = '/cart'; } }
      else { window.location.href = '/cart'; }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'seqr-home', cartData: res }); }
      btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = label; }, 1800);
    }).catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } btn.textContent = label; })
      .finally(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-seqr-add]');
    if (add) { e.preventDefault(); addItem(add.getAttribute('data-seqr-add'), add); return; }
    var swap = e.target.closest('[data-swap-paper]');
    if (swap) {
      var tag = swap.closest('.why-demo').querySelector('[data-paper-tag]');
      var on = tag.classList.toggle('sealed');
      swap.setAttribute('aria-pressed', String(on));
      swap.textContent = on ? swap.getAttribute('data-on') : swap.getAttribute('data-off');
      var lbl = tag.querySelector('[data-pt-label]');
      if (lbl) lbl.textContent = on ? lbl.getAttribute('data-after') : lbl.getAttribute('data-before');
    }
  });
})();
